import { Type } from '@angular/core';
import { GameId } from 'src/app/shared/models/game/game-id';
import { BlocksTutorialComponent } from './blocks-tutorial/blocks-tutorial.component';
import { BlackjackTutorialComponent } from './blackjack-tutorial/blackjack-tutorial.component';
import { MarblesTutorialComponent } from './marbles-tutorial/marbles-tutorial.component';
import { SolitaireTutorialComponent } from './solitaire-tutorial/solitaire-tutorial.component';
import { GameTutorial } from './game-tutorial';
import { TwentyOneTutorialComponent } from './twentyone-tutorial/twentyone-tutorial.component';
import { SlotsTutorialComponent } from './slots-tutorial/slots-tutorial.component';
import { PlinkoTutorialComponent } from './plinko-tutorial/plinko-tutorial.component';

export const GAME_TUTORIAL_COMPONENT_MAP: Partial<Record<GameId, Type<GameTutorial>>> = {
  [GameId.Blocks]: BlocksTutorialComponent,
  [GameId.Blackjack]: BlackjackTutorialComponent,
  [GameId.Marbles]: MarblesTutorialComponent,
  [GameId.Solitaire]: SolitaireTutorialComponent,
  [GameId.TwentyOne]: TwentyOneTutorialComponent,
  [GameId.Slots]: SlotsTutorialComponent,
  [GameId.Plinko]: PlinkoTutorialComponent,
  // TODO(videopoker): add tutorial component before release
  // TODO(hilo): add tutorial component before release
  // TODO(bingo): add tutorial component before release
};
